import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {DepartureIndexModule} from './departure-index/departure-index.module';
import {HeaderModule} from './header/header.module';

@NgModule({
  imports: DASCoreModule.IMPORTS,
  exports: DASCoreModule.EXPORTS
})
export class DASCoreModule {
  private static readonly ERROR_MESSAGE: string = 'The core module should only be imported once; in the root module.';

  public static readonly IMPORTS: any[] = [CommonModule, HttpClientModule, HeaderModule, DepartureIndexModule];

  public static readonly EXPORTS: any[] = [HeaderModule, DepartureIndexModule];

  constructor(
    @Optional()
    @SkipSelf()
    core: DASCoreModule
  ) {
    if (core) {
      throw new Error(DASCoreModule.ERROR_MESSAGE);
    }
  }
}
